import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        loading: false,
        baseurl: "https://academiacocacola.com.mx/api/",
        homeurl: "https://academiacocacola.com.mx/",
        user: {
            nombre: '',
            apellido: '',
            email: ''
        },
        user_reportes: {
            nombre_usuario: ''
        },
        ciclo_escolar: null,
        ciclo_escolar_ano: null,
        cursos: setCursos(),
        subcursos: setSubscursos(),
        ids: setIds(),
        pass: 'academiadigital',


    }
});

function setIds() {


    return [
        "0000",

        4573,

        3824,

        5061,

        3818,

        3831,

        3819,

        3053,

        3840,

        5462,

        3809,

        3817,

        5817,

        3915,

        1053,

        3896,

        3812,

        1112,

        2052,

        1249,

        1159,

        1147,

        3839,

        3223,

        3397,

        2766,

        3810,

        3025,

        1100,

        2092,

        3826,

        4170,

        3842,

        4581,

        1118,

        1075,

        5796,

        1020,

        2220,

        1196,

        3034,

        3844,

        3841,

        5773,

        3035,

        3825,

        1160,

        1248,

        3054,

        3906,

        3921,

        3881,

        3816,

        2895,

        3834,

        3820,

        3835,

        3815,

        3843,

        3813,

        1247,

        1074,

        2574,

        3479,

        3827,

        3838,

        5815,

        1528,

        3199,

        4543,

        3832,

        3629,

        3829,

        3830,

        3814,

        2093,

        1627,

        1039,

        2830,

        1408,

        3811,

        3828,

        3480,

        3941,

        4544,

        3833,

        3837,

        4063,

        2829,

        1492,

        3212,

        3821,

        3849,

        2805,

        3177,

        3140,

        5015,

        4956,

        5115,

        4666
    ];
}


function setCursos() {
    var cursos = {};

    var curso = {};

    curso = {
        id: 'enfriadores',
        clase: "Enfriadores",
        nombre_amigable: "enfriadores",
        objetivo: "",
        videotxt: "Volver a ver",
        order: 8,
        youtube: "",
        poster: 'poster-master-1.jpg',
        video: "",
        quiz_activo: true,
        activo: true,
        completo: false,
        evaluacion: [],
        index_quiz: 0,
        quiz: [],
        descripcion: `
        <p>Para poder realizar el correcto llenado del enfriador, 
        lo primero que debemos hacer es conocer la rutina 
        y el modelo el que vas a trabajar.</p>

        <p>Da click en el video y conoce la rutina del enfriador</p>
        `,
        instrucciones: `
        <div class='row'>
        <div class='col-1'><span class='numero'><span>1</span></span></div>
        <div class='col-11 rojo fR'><div class="px-3">De las siguientes imágenes, selecciona el modelo 
        que corresponde al enfriador que vas a trabajar.</div></div>
        </div>
        `,
        modelos: true,
        subcursos: [{
                id: 'VL105',
                nombre: `Modelo <strong>VL105</strong>`,
                ubicacion: 'Ubicación: Zona de caja',
                imagen: 'vl105.png',
                titulo: `Sigue estos sencillos pasos para conocer el correcto llenado de enfriadores`,
                descripcion: `
                <p>El enfriador <strong>VL105</strong> se encuentra en la zona de cajas, cuenta con 1 puerta y tienes 3 charolas.</p>

                <p>La Secuencia del  planograma lo podrás consultar  en tu TC70.</p>

                <p>
                    <strong>Da clic en la cápsula para ver la rutina del enfriador VL105</strong>
                </p>
                `,
                checklist: [

                    "Confirma que el enfriador esté debidamente conectado y funcione correctamente.",

                    "La luz interna debe funcionar perfectamente.",

                    "Asegúrate de que los cristales estén limpios.",

                    "Al iniciar tu rutina recuerda tener a la mano la TC70 para confirmar planogramas y precios.",

                    "Acomoda el producto y asegúrate de que todos cuenten con el hogar modular y/o secuencia correcta, así como el volumen adecuado acorde a su capacidad.",

                    "Escanea el código QR para conocer la rutina de los enfriadores.",

                    "Reconfirma el planograma en la TC70 y revisa el producto que falta.",

                    "Toma el producto que haga falta de la bodega, o en su defecto de los anaqueles para colocarlo en los enfriadores.",

                    "Recuerda que el producto con caducidad próxima y frío debe de ir al frente y el que está a temperatura ambiente se colocará en la parte posterior.",

                    "No olvides señalizar promociones y actualizar precios.",

                    "Contamos con una sección de tips que te ayudarán a generar una ejecución correcta en el Punto de Venta.",

                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Si los enfriadores presentan alguna falla repórtala de 
                    inmediato al comprador o asociado a cargo.
                    Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, el enfriador ya está listo!</p>
                `,
                video: '_6r2AN5uxzw',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },
            {
                id: 'VRD41',
                nombre: `Modelo <strong>VRD41</strong>`,
                ubicacion: 'Ubicación: Zona de caja',
                imagen: 'vrd41.png',
                titulo: `Sigue estos sencillos pasos para conocer el correcto llenado de enfriadores`,
                descripcion: `
                <p>El enfriador <strong>VRD41</strong> se encuentra en la zona de cajas, cuenta con 2 puertas y tienes 3 charolas. 
                </p>

                <p>La Secuencia del  planograma lo podrás consultar  en tu TC70.</p>

                <p>
                    <strong>Da clic en la cápsula para ver la rutina del enfriador VRD41</strong>
                </p>
                `,
                checklist: [

                    'Confirma que el enfriador esté debidamente conectado y funcione correctamente.',

                    'La luz interna debe funcionar perfectamente.',

                    'Asegúrate de que los cristales estén limpios.',

                    'Al iniciar tu rutina recuerda tener a la mano la TC70 para confirmar planogramas y precios.',

                    'Acomoda el producto y asegúrate de que todos cuenten con el hogar modular y/o secuencia correcta, así como el volumen adecuado acorde a su capacidad.',

                    'Escanea el código QR para conocer la rutina de los enfriadores.',

                    'Reconfirma el planograma en la TC70 y revisa el producto que falta.',

                    'Toma el producto que haga falta de la bodega, o en su defecto de los anaqueles para colocarlo en los enfriadores.',

                    'Recuerda que el producto con caducidad próxima y frío debe de ir al frente y el que está a temperatura ambiente se colocará en la parte posterior.',

                    'No olvides señalizar promociones y actualizar precios.',

                    'Contamos con una sección de tips que te ayudarán a generar una ejecución correcta en el Punto de Venta.',

                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Si los enfriadores presentan alguna falla repórtala de 
                    inmediato al comprador o asociado a cargo.
                    Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, el enfriador ya está listo!</p>
                `,
                video: 'cZFKqIYQqW4',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },
            {
                id: 'camara-fria',
                nombre: `<strong>Cámara fría</strong>`,
                ubicacion: 'Ubicación: Pasillo Punto de Venta',
                imagen: 'camara-fria.png',
                titulo: `Sigue estos sencillos pasos para conocer el correcto llenado de enfriadores`,
                descripcion: `
                <p>La <strong>Cámara Fría</strong> se encuentra en el pasillo del Punto de Venta, cuenta con 1 puerta y tienes 3 charolas. 
                </p>

                <p>En el caso que la tienda cuente con un espacio adicional en el área de enfriadores, podrás colocar producto que te ayudará a aumentar las ventas . No olvides visitar la sección de tips para generar una ejecución correcta en el Punto de Venta.
                </p>

                <p>
                    <strong>Da clic en la cápsula para ver la rutina del enfriador Cámara Fría</strong>
                </p>
                `,
                checklist: [

                    'Confirma que el enfriador esté debidamente conectado y funcione correctamente.',

                    'La luz interna debe funcionar perfectamente.',

                    'Asegúrate de que los cristales estén limpios.',

                    'Al iniciar tu rutina recuerda tener a la mano la TC70 para confirmar planogramas y precios.',

                    'Acomoda el producto y asegúrate de que todos cuenten con el hogar modular y/o secuencia correcta, así como el volumen adecuado acorde a su capacidad.',

                    'Escanea el código QR para conocer la rutina de los enfriadores.',

                    'Reconfirma el planograma en la TC70 y revisa el producto que falta.',

                    'Toma el producto que haga falta de la bodega, o en su defecto de los anaqueles para colocarlo en los enfriadores.',

                    'Recuerda que el producto con caducidad próxima y frío debe de ir al frente y el que está a temperatura ambiente se colocará en la parte posterior.',

                    'No olvides señalizar promociones y actualizar precios.',

                    'Contamos con una sección de tips que te ayudarán a generar una ejecución correcta en el Punto de Venta.',

                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Si los enfriadores presentan alguna falla repórtala de 
                    inmediato al comprador o asociado a cargo.
                    Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, el enfriador ya está listo!</p>
                `,
                video: 'MHsotT03qvk',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },

        ]
    };
    cursos['enfriadores'] = curso;



    curso = {
        id: 'anaqueles',
        clase: "Anaqueles",
        nombre_amigable: "anaqueles",
        objetivo: "",
        videotxt: "Volver a ver",
        order: 8,
        youtube: "",
        poster: 'poster-master-1.jpg',
        video: "",
        quiz_activo: true,
        activo: true,
        completo: false,
        evaluacion: [],
        index_quiz: 0,
        quiz: [],
        descripcion: `
        
        
        `,
        instrucciones: `
        <div class='row'>
        <div class='col-1'><span class='numero'><span>1</span></span></div>
        <div class='col-11 rojo fR'><div class="px-3">De las siguientes imágenes, selecciona la categoría 
        que vas a trabajar.</div></div>
        </div>
        `,
        modelos: true,
        subcursos: [{
                id: 'categoria-1',
                nombre: `<strong>Colas - Frutales - Agua Mineral</strong>`,
                ubicacion: '',
                imagen: 'anaqueles_colas_frutales.png',
                titulo: ``,
                descripcion: `
                <p>La categorías de colas, bebidas frutales y aguas minerales las podrás encontrar en el mismo pasillo 
                </p>

                <p>La Secuencia del  planograma lo podrás consultar  en tu TC70.</p>

                <p><strong>Da clic en la cápsula para ver la del anaquel</strong></p>
                `,
                checklist: [
                    'Cada 45 minutos debes de hacer tu zona de defensa: reposicionamiento de mercancía, limpieza, precio, rotación y careo de toda la categoría',
                    'La Secuencia del  planograma lo podrás consultar  en tu TC70',
                    'Escanea el código QR para conocer la rutina de los anaqueles',
                    'Debes de señalizar promociones, actualiza precios y validar caducidades',
                    'Anota el producto que te hace falta y retira de la bodega lo que necesitas',
                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, la sección está lista!</p>
                `,
                video: 'r1AwmbxinsQ',
                video2: 'LNxdm-iwSHY',
                video3: '1zaE1znM5W0',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },
            {
                id: 'categoria-2',
                nombre: `<strong>Agua Purificada - Bebidas hechas a base de jugo - Isotónicos</strong>`,
                ubicacion: '',
                imagen: 'anaqueles-aguas.png',
                titulo: ``,
                descripcion: `
                <p>Las categorías de agua purificada, jugos y bebidas hechas a base de jugo e isotónicos los podrás encontrar en el mismo pasillo.

                </p>

                <p>La Secuencia del  planograma lo podrás consultar  en tu TC70.</p>

                <p><strong>Da clic en la cápsula para ver la del anaquel</strong></p>
                `,
                checklist: [
                    'Cada 45 minutos debes de hacer tu zona de defensa: reposicionamiento de mercancía, limpieza, precio, rotación y careo de toda la categoría',
                    'La Secuencia del  planograma lo podrás consultar  en tu TC70',
                    'Escanea el código QR para conocer la rutina de los anaqueles',
                    'Debes de señalizar promociones, actualiza precios y validar caducidades',
                    'Anota el producto que te hace falta y retira de la bodega lo que necesitas',
                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, la sección está lista!</p>
                `,
                video: 'hY8ISAuEMGw',
                video2: 's6bDvYAa0CQ',
                video3: '',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },
            {
                id: 'categoria-3',
                nombre: `<strong>Leches - Ades Lácteo - Leches Saborizadas</strong>`,
                ubicacion: '',
                imagen: 'anaqueles_leches.png',
                titulo: ``,
                descripcion: `
                <p>Las categorías de leches (tetra pack y pet), Ades lácteo y leches saborizadas las podrás encontrar en el mismo pasillo.  
                </p>

                <p>La Secuencia del  planograma lo podrás consultar  en tu TC70.</p>

                <p><strong>Da clic en la cápsula para ver la del anaquel</strong></p>
                `,
                checklist: [
                    'Al reposicionar la mercancía debemos de colocar los artículos del fondo en el frente, para que el producto mantenga la rotación apropiada y llenar adecuadamente según la capacidad del hogar modular de toda la categoría y mantener limpia la exhibición.',

                    'Confirma la guía de acomodo (planograma) en tu TC70.',

                    'Escanea el código QR para conocer la rutina de los anaqueles.',

                    'Debes de mantener los precios actualizados, señalar promociones y validar caducidades.',

                    'Elabora la Lista Pick dentro de tu TC70 y retira de la bodega el producto que necesites.',

                    'Reconfirma que el planograma esté siguiendo la secuencia modular.',

                    'Confirma la guía de acomodo (planograma) en tu TC70.',

                    'Asegúrate de que los cristales estén limpios.',

                    'Recuerda que el producto con caducidad más próxima debe de ir al frente y retira el producto que esté próximo a caducar conforme a las vigencias de Seguridad Alimentaria.',

                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, la sección está lista!</p>
                `,
                video: 'Gj12WdTKHbQ',
                video2: 'PMHNmvCWXAk',
                video3: 'N-4oLTkprYA',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },
            {
                id: 'categoria-4',
                nombre: `<strong>Derivados: Yogurt, crema, otros</strong>`,
                ubicacion: '',
                imagen: 'derivados-yogurt.png',
                titulo: ``,
                descripcion: `
                    <p>La categoría de derivados, yogurt, crema, etc. los podrás encontrar en la misma sección. 

                    </p>

                    <p>La Secuencia del  planograma lo podrás consultar  en tu TC70.</p>

                    <p><strong>Da clic en la cápsula para ver la del anaquel</strong></p>
                `,
                checklist: [
                    'Cada 45 minutos debes de hacer tu zona de defensa: reposicionamiento de mercancía, limpieza, precio, rotación y careo de toda la categoría ',
                    'Confirma la secuencia del (planograma) en tu TC70 ',
                    'Escanea el código QR para conocer la rutina de los anaqueles',
                    'Recuerda que el producto con caducidad más próxima debe de ir al frente',
                    'Señalizar promociones, actualiza precios y valida caducidades',
                    'Anota el producto que te hace falta y retira de la bodega lo que necesitas ',
                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, la sección está lista!</p>
                `,
                video: '5kY61fJpwsk',
                video2: '',
                video3: '',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },
            {
                id: 'categoria-5',
                nombre: `<strong>Hard Seltzers</strong>`,
                ubicacion: '',
                imagen: 'anaqueles_hardselzers.png',
                titulo: ``,
                descripcion: `
                    <p>Hard Seltzers los podrás encontrar en el área de alcohol 

                    </p>

                    <p>La Secuencia del  planograma lo podrás consultar  en tu TC70.</p>

                    <p><strong>Da clic en la cápsula para ver la del anaquel</strong></p>
                `,
                checklist: [
                    'Cada 45 minutos debes de hacer tu zona de defensa: reposicionamiento de mercancía, limpieza, precio, rotación y careo de toda la categoría ',
                    'Confirma la secuencia  de acomodo (planograma) en tu TC70',
                    'Escanea el código QR para conocer la rutina de los anaqueles',
                    'Señaliza promociones, actualiza precios y valida caducidades',
                    'Anota el producto que te hace falta y retira de la bodega lo que necesitas',
                    'Hard Seltzer también se encuentran en enfriadores en el área de alcohol ',
                    'Asegúrate que los cristales estén limpios ',
                    'Recuerda que el producto con caducidad más próxima debe de ir al frente',
                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, la sección está lista!</p>
                `,
                video: '9e9jo8a25lk',
                video2: '',
                video3: '',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },

        ]
    };
    cursos['anaqueles'] = curso;



    curso = {
        id: 'exhibiciones-adicionales',
        clase: "Exhibiciones Adicionales",
        nombre_amigable: "exhibiciones adicionales",
        objetivo: "",
        videotxt: "Volver a ver",
        order: 8,
        youtube: "",
        poster: 'poster-master-1.jpg',
        video: "",
        quiz_activo: true,
        activo: true,
        completo: false,
        evaluacion: [],
        index_quiz: 0,
        quiz: [],
        descripcion: `
        
        <p>Aquí encontrarás ideas para puntos estratégicos dentro del punto de venta</p>
        `,
        instrucciones: `
        <div class='row'>
        <div class='col-1'><span class='numero'><span>1</span></span></div>
        <div class='col-11 rojo fR'><div class="px-3">De las siguientes imágenes, selecciona la categoría 
        que vas a trabajar.</div></div>
        </div>
        `,
        modelos: false,
        subcursos: [{
                id: 'exhibicion-1',
                nombre: `<strong>Exhibiciones Adicionales</strong>`,
                ubicacion: '',
                imagen: 'modelo-vrd41.png',
                titulo: ``,
                descripcion: `
                    <p>Bienvenido a la sección de <strong>Exhibiciones Adicionales</strong>, aquí encontrarás ideas para puntos estratégicos dentro del punto de venta
                    </p>

                    
                `,
                checklist: [
                    'Realiza tu zona de defensa y acomoda el producto correcto',
                    'Realiza el correcto reposicionamiento de mercancía, limpieza, precio, rotación, careo',
                    'Anota el producto que te hace falta y retira de la bodega lo que necesitas',
                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, tu exhibición está lista!</p>
                `,
                video: '',
                fotos: [
                    'ea1.jpg',
                    'ea2.jpg',
                    'ea3.jpg',
                    'ea4.jpg',
                    'ea5.jpg',
                    'ea6.jpg',
                    'ea7.jpg',
                    'ea8.jpg',
                    'ea9.jpg',
                    'ea10.jpg',
                    'ea11.jpg',
                    'ea12.jpg',
                    'ea13.jpg',
                    'ea14.jpg',
                    'ea15.jpg',
                    'ea16.jpg',
                    'ea17.jpg',
                    'ea18.jpg',
                    'ea19.jpg',
                    'ea20.jpg',
                    'ea21.jpg',
                    'ea22.jpg',
                    'ea23.jpg',
                    'ea24.jpg',
                ],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },

        ]
    };
    cursos['exhibiciones-adicionales'] = curso;


    curso = {
        id: 'bodega',
        clase: "Bodega",
        nombre_amigable: "bodega",
        objetivo: "",
        videotxt: "Volver a ver",
        order: 8,
        youtube: "",
        poster: 'poster-master-1.jpg',
        video: "",
        quiz_activo: true,
        activo: true,
        completo: false,
        evaluacion: [],
        index_quiz: 0,
        quiz: [],
        descripcion: `
        
        <p>Aquí encontrarás ideas para puntos estratégicos dentro del punto de venta</p>
        `,
        instrucciones: `
        <div class='row'>
        <div class='col-1'><span class='numero'><span>1</span></span></div>
        <div class='col-11 rojo fR'><div class="px-3">De las siguientes imágenes, selecciona la categoría 
        que vas a trabajar.</div></div>
        </div>
        `,
        modelos: false,
        subcursos: [{
                id: 'bodega-1',
                nombre: `<strong>Bodega</strong>`,
                ubicacion: '',
                imagen: 'modelo-vrd41.png',
                titulo: ``,
                descripcion: `
                    <p>En esta sección conocerás el proceso para el abastecimiento de productos faltante de anaquel, enfriadores y exhibiciones adicionales, así como el proceso de  toma de producto de la bodega.

                    </p>

                    
                `,
                checklist: [
                    'Administrar caducidades según el tipo de producto',
                    'Estibas adecuadas según Marca / Producto',
                    'Monitorear la llegada del producto',
                    'Separación por Categorías / Marcas para su fácil localización',
                    'Cuadrar inventarios físico Vs teórico',
                ],
                titulochecklist2: "Validación de productos:",
                checklist2: [
                    'Administrar caducidades según el tipo de producto',
                    'Estibas adecuadas según Marca / Producto',
                    'Monitorear la llegada del producto',
                    'Separación por Categorías / Marcas para su fácil localización',
                    'Cuadrar inventarios físico Vs teórico',
                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    <p class='fG rojo bold text-center'>¡Excelente trabajo, tu bodega está ordenada!</p>
                `,
                video: '',
                fotos: [],
                levantarticket: true,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },

        ]
    };
    cursos['bodega'] = curso;


    curso = {
        id: 'tips',
        clase: "Tips",
        nombre_amigable: "tips",
        objetivo: "",
        videotxt: "Volver a ver",
        order: 8,
        youtube: "",
        poster: 'poster-master-1.jpg',
        video: "",
        quiz_activo: true,
        activo: true,
        completo: false,
        evaluacion: [],
        index_quiz: 0,
        quiz: [],
        descripcion: `
        
        <p>Aquí encontrarás ideas para puntos estratégicos dentro del punto de venta</p>
        `,
        instrucciones: `
        <div class='row'>
        <div class='col-1'><span class='numero'><span>1</span></span></div>
        <div class='col-11 rojo fR'><div class="px-3">De las siguientes imágenes, selecciona la categoría 
        que vas a trabajar.</div></div>
        </div>
        `,
        modelos: false,
        subcursos: [{
                id: 'tips-1',
                nombre: `<strong>Tips</strong>`,
                ubicacion: '',
                imagen: 'modelo-vrd41.png',
                titulo: ``,
                descripcion: `
                    <p>Aquí encontrarás Tips que te ayudarán en el día a día y a mejorar tus exhibiciones.
                    Para tener una ejecución correcta en el Punto de Venta, debes de considerar:
                    
                    </p>

                    
                `,
                checklist: [
                    'Antes de empezar tu rutina debes de tener siempre a la mano tu equipo de protección personal, faja, chaleco, así como cubrebocas, careta y gel ',
                    'Una vez que entres a tu turno no olvides recorrer todos lo pasillos y hacer tu zona de defensa ',
                    'Realiza la toma fotográfica con tu TC70 para reportar el producto faltante por medio de Plant It',
                    'Realiza tu zona de defesa cada 45 minutos ',
                    'Reporta los productos faltantes o en mal estado ',
                    'Asegúrate que este limpio y en buen estado el PDV',
                ],
                titulochecklist2: "El acomodo de enfriadores tiene que ser:",
                checklist2: [
                    'Colas / Innovaciones / Hidratación / Sabores',
                    '50% Colas y 50% sabores',
                    'En la parte superior coloca los productos de menor mililitros y los de mayor millaraje en la parte inferior',
                ],
                nota: `
                    <p class='fG rojo bold'>¡No olvides!</p>
                    <p class='fR'>Para consultar cambios de precios, abasto o información en general, contacta  al  jefe de área o personal de gerencia.</p>
                `,
                despedida: `
                    
                `,
                video: '',
                fotos: [],
                levantarticket: false,
                textoticket: "Para reabastecer producto agotado y generar pedidos adicionales, levantar un ticket:",
                textobotonticket: "Solicitar Producto"
            },

        ]
    };
    cursos['tips'] = curso;




    return cursos;

}

function setSubscursos() {
    var cursos = [];

    return cursos;

}